import element from "@/store/modules/learning/element";
import library from "@/store/modules/learning/library";
import path from "@/store/modules/learning/path";
import progress from "@/store/modules/learning/progress";
import certificate from "@/store/modules/learning/certificate";
import storage from "@/store/modules/learning/storage";

export default {
    namespaced: true,
    modules: {
        element,
        library,
        path,
        progress,
        certificate,
        storage,
    },
};
